// extracted by mini-css-extract-plugin
export default {"root":"styles_root__eSmXU","header":"styles_header__RiONa","breadcrumb":"styles_breadcrumb__EYFGC","contentWrapper":"styles_contentWrapper__r+rqn"};